/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { darken, lighten } from '@/utils/colors'
import Error from './Error'
import Disclaimer from './Disclaimer'
import DeclineBalance from './DeclineBalance'
import GlobalAllowance from './GlobalAllowance'

class GlobalConfiguration {
  private json: any
  public readonly clientId: string
  public readonly flowIdList: string
  public readonly fpFlowId: string
  public readonly primaryColor: string
  public readonly secondaryColor: string
  public readonly tertiaryColor: string
  public readonly locale: string
  public readonly footerDisclaimer:string
  public readonly disclaimerModalContent: Disclaimer
  public readonly declineBalanceContent: DeclineBalance
  public readonly globalAllowanceContent: GlobalAllowance
  public readonly errorContent: Error

  constructor (data: any, memberwebData?: any) {
    this.json = data
    this.clientId = this.json.client_id
    this.flowIdList = this.json.flow_id_list
    this.fpFlowId = this.json.fp_flow_id || ''
    if (memberwebData) {
      this.primaryColor = memberwebData.data.primary_color
      this.secondaryColor = lighten(this.primaryColor, Number(this.json.lighten))
      this.tertiaryColor = darken(this.primaryColor, Number(this.json.darken))
    } else {
      this.primaryColor = this.json.primary_color
      this.secondaryColor = this.json.secondary_color || lighten(this.json.primary_color, Number(this.json.lighten))
      this.tertiaryColor = this.json.third_color || darken(this.json.primary_color, Number(this.json.darken))
    }
    this.locale = this.json.locale
    this.footerDisclaimer = this.json.footer_disclaimer
    this.disclaimerModalContent = Disclaimer.of(this.json.disclaimer)
    this.declineBalanceContent = DeclineBalance.of(this.json.decline_balance)
    this.globalAllowanceContent = GlobalAllowance.of(this.json.global_allowance)
    this.errorContent = Error.of(this.json.error_message)
  }

  static of (data: any, memberwebData?: any): GlobalConfiguration {
    return new GlobalConfiguration(data, memberwebData)
  }
}

export default GlobalConfiguration
